// extracted by mini-css-extract-plugin
export var emailInputBubbleContainer = "_kg-0";